var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7608_165553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.40776 14.8158H5.29126V20.107H10.5825V17.9905H7.40776V14.8158ZM5.29126 10.5828H7.40776V7.40801H10.5825V5.2915H5.29126V10.5828ZM17.9903 17.9905H14.8155V20.107H20.1068V14.8158H17.9903V17.9905ZM14.8155 5.2915V7.40801H17.9903V10.5828H20.1068V5.2915H14.8155Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7608_165553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.3981,
    height: 25.3981,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/full-screen.cf8f359f82c55db8a7a9bdcafc8e3249.svg";
export { ForwardRef as ReactComponent };